// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eK6Y","content":"styles_content__1O0Yt"};